/**
 * 自动生成， 请不要手工修改！
 */

export enum CustomMessageResponseType {
  RESP_USER_AD,
  RESP_ANNOUNCE,
  RESP_ACTIVITY,
}
